'use es6';

import Widget from 'DesignData/models/widgets/Widget';
import * as smartObjectHelper from 'DesignData/helpers/smartObjectHelper';
import { omit } from 'underscore';
/**
 * Wrapper class of Global Widget Summary data.
 */

export default class GlobalWidgetSummary extends Widget {
  /**
   * @constructor
   */
  constructor(rawProps) {
    // smart content properties should be saved in "body" and snake-cased
    const props = omit(rawProps, ['definitionId', 'smartObjects', 'smartType', 'smartTypeId']);
    return super(props).set('widgetType', props.type).set('type', 'global_widget');
  }
  /**
   * Returns an object widget with minimum requirements for use in a layout's tree.
   *
   * @override
   * @return {Object}
   */


  generateNewLayoutWidgetObject() {
    const {
      name
    } = this;
    const superWidgetObject = super.generateNewLayoutWidgetObject();
    return Object.assign({}, superWidgetObject, {
      name,
      params: Object.assign({}, superWidgetObject.params, {
        overrideable: false
      })
    });
  }

  getSmartProperties() {
    return smartObjectHelper.getSmartProperties(this.body);
  }

  getTargetType() {
    return smartObjectHelper.getTargetType(this.widgetType);
  }

  getTargetContentType() {
    return smartObjectHelper.getTargetContentType(this.widgetType);
  }

  getTargetedContent() {
    return smartObjectHelper.getTargetedContent(this.widgetType, this.body);
  }

}